import * as React from 'react';
import {Table} from "nca-acquiring-theme";

export const TransactionSearchSupportedFieldsTable = () => {
  return (
    <Table>
      <thead>
      <tr>
        <th>Field Name</th>
        <th>Field Type</th>
        <th>Description</th>
      </tr>
      </thead>
        <tbody>
        <tr>
            <td>timestamp</td>
            <td>Date</td>
            <td>Date and time of the transaction creation.</td>
        </tr>
        <tr>
            <td>dsTransID</td>
            <td>Keyword, UUID formatted</td>
            <td>Universally unique transaction identifier assigned by the DS to identify the transaction.</td>
        </tr>
        <tr>
            <td>threedsServerTransID</td>
            <td>Keyword, UUID formatted</td>
            <td>Universally unique transaction identifier assigned by the 3DS Server to identify the transaction.</td>
        </tr>
        <tr>
            <td>sdkTransID</td>
            <td>Keyword, UUID formatted</td>
            <td>Universally unique transaction identifier assigned by the 3DS SDK to identify the transaction.</td>
        </tr>
        <tr>
            <td>acsTransID</td>
            <td>Keyword, UUID formatted</td>
            <td>Universally Unique transaction identifier assigned by the ACS to identify the transaction.</td>
        </tr>
        <tr>
            <td>priorDsTransID</td>
            <td>Keyword, UUID formatted</td>
            <td>DS Trx ID of the preceding transactions in the context SPC authentication.</td>
        </tr>
        <tr>
            <td>priorAcsTransID</td>
            <td>Keyword, UUID formatted</td>
            <td>ASC Trx ID of the preceding transactions in the context SPC authentication.</td>
        </tr>
        <tr>
            <td>protocolVersion</td>
            <td>Keyword, values: 2.1.0, 2.2.0 and 2.3.1</td>
            <td>EMV 3DS protocol version number utilized to execute the transaction.</td>
        </tr>
        <tr>
            <td>deviceChannel</td>
            <td>Keyword, values: APPLICATION, BROWSER, THREE_RI</td>
            <td>The type of channel interface being used to initiate the transaction.</td>
        </tr>
        <tr>
            <td>messageCategory</td>
            <td>Keyword, values: PAYMENT, NON_PAYMENT</td>
            <td>The category of the EMV 3DS message for a specific use case.</td>
        </tr>
        <tr>
            <td>acquirerBIN</td>
            <td>Keyword</td>
            <td>Acquiring institution identification code as assigned by the DS.</td>
        </tr>
        <tr>
            <td>merchantName</td>
            <td>Keyword</td>
            <td>Merchant name assigned by the Acquirer or Payment System.</td>
        </tr>
        <tr>
            <td>merchantID</td>
            <td>Keyword</td>
            <td>Acquirer-assigned merchant identifier.</td>
        </tr>
        <tr>
            <td>merchantCountry</td>
            <td>Keyword, values: DE, AT, CH, etc</td>
            <td>Country code of the merchant.</td>
        </tr>
        <tr>
            <td>merchantCategoryCode</td>
            <td>Keyword, 4 digits value</td>
            <td>DS-specific code describing the Merchant’s type of business, product or service.</td>
        </tr>
        <tr>
            <td>acsOperatorID</td>
            <td>Keyword</td>
            <td>DS assigned ACS identifier.</td>
        </tr>
        <tr>
            <td>threeDSServerOperatorID</td>
            <td>Keyword</td>
            <td>DS assigned 3DS Server identifier.</td>
        </tr>
        <tr>
            <td>maskedPAN</td>
            <td>Keyword</td>
            <td>Masked account number of the cardholder.</td>
        </tr>
        <tr>
            <td>issuerID</td>
            <td>Keyword</td>
            <td>Issuer identifier configured at BIN range level.</td>
        </tr>
        <tr>
            <td>amount</td>
            <td>Keyword</td>
            <td>Purchase amount in the currency provided in the "Currency" field. The minor units are separated by "."
                (dot
                character).
            </td>
        </tr>
        <tr>
            <td>currency</td>
            <td>Keyword, alphabetical ISO code: EUR, USD, CHF, etc</td>
            <td>Currency in which purchase amount is expressed.</td>
        </tr>
        <tr>
            <td>finalTransStatus</td>
            <td>Keyword, values: Y, N, U, E, T</td>
            <td>Terminal status of the transaction:
                <br/>
                Y - authentication verification successful
                <br/>
                N - not authenticated
                <br/>
                U - Authentication could not be performed; technical or other problem encountered in DS or ACS
                <br/>
                E - Error in the transaction processing
                <br/>
                T - Timed out transaction
            </td>
        </tr>
        <tr>
            <td>transStatusReason</td>
            <td>Keyword, values: CARD_AUTHENTICATION_FAILED, UNKNOWN_DEVICE, EXPIRED_CARD, etc</td>
            <td>Provides information on why the transaction status field has the specified value. Check EMV 3DS
                specification for all possible values.
            </td>
        </tr>
        <tr>
            <td>transFlowType</td>
            <td>Keyword: values: F, C, D, S</td>
            <td>The EMV 3DS flow utilized to execute the transaction:
                <br/>
                F - frictionless flow
                <br/>
                C - challenge flow
                <br/>
                D - decoupled authentication flow
                <br/>
                S - secure payment confirmation flow
            </td>
        </tr>
        <tr>
            <td>protocolMessages.timestamp</td>
            <td>Date</td>
            <td>Date and time when the EMV 3DS message arrived to the DS.</td>
        </tr>
        <tr>
            <td>protocolMessages.content</td>
            <td>Text</td>
            <td>EMV 3DS Message in JSON format.</td>
        </tr>
        <tr>
            <td>protocolMessages.type</td>
            <td>Keyword, values: AReq, ARes, RReq, RRes, Erro</td>
            <td>Type of the EMV 3DS message.</td>
        </tr>
        </tbody>
    </Table>)
}